/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const BoxDev16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray}
            fillRule="evenodd"
            d="M10.229 2c.385 0 .756.133 1.05.374l.12.11 4.121 4.094c.602.615.638 1.57.103 2.229l-.107.12-4.115 4.089a1.657 1.657 0 01-2.224.109l-.121-.11-1.058-1.064-1.077 1.065a1.67 1.67 0 01-2.229.11l-.122-.11L.482 8.923a1.668 1.668 0 01-.104-2.229l.107-.12 4.086-4.09a1.67 1.67 0 012.229-.11l.122.11 1.062 1.064 1.073-1.064c.31-.31.732-.484 1.172-.484zm0 1a.657.657 0 00-.387.125l-.08.068-1.07 1.063 2.312 2.315c.623.612.66 1.585.11 2.24l-.11.118-.675.662a.5.5 0 01-.759-.645l.059-.07.674-.66a.648.648 0 00.068-.852l-.072-.083-4.084-4.089a.668.668 0 00-.859-.067l-.078.066L1.195 7.28a.666.666 0 00-.072.857l.07.083 4.084 4.089a.667.667 0 00.859.066l.08-.067 1.077-1.066-2.3-2.313a1.652 1.652 0 01-.108-2.237l.109-.119.67-.662a.5.5 0 01.761.643l-.058.07-.67.66a.652.652 0 00-.069.854l.072.083 4.064 4.089a.658.658 0 00.851.066l.08-.067 4.111-4.086a.67.67 0 00.073-.857l-.068-.082-4.118-4.092A.658.658 0 0010.23 3z"
        />
    </AccessibleSVG>
);

export default BoxDev16;
